<template>
  <v-data-table
    class="grow"
    :headers="deletable ? [...headers, {value: 'actions', align: 'right', sortable: false}] : headers"
    :search="search"
    :items="items"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        class="mx-4"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      />
    </template>
    <template v-slot:item="props">
      <tr>
        <td
          v-for="(header, i) in headers"
          :key="header.key + '-' + i"
        >
          <v-edit-dialog
            v-if="props.item[header.value] && header.editable"
            large
            :return-value.sync="props.item[header.value]"
            @save="$emit('save', items)"
          >
            {{ props.item[header.value] }} <v-icon
              class="mb-1 ml-1"
              small
            >
              mdi-pencil
            </v-icon>
            <template
              v-if="props.item[header.value].length <= 126"
              v-slot:input
            >
              <v-text-field
                v-model="props.item[header.value]"
                label="Edit"
                single-line
              />
            </template>
            <template
              v-else
              v-slot:input
            >
              <v-textarea
                v-model="props.item[header.value]"
                label="Edit"
                single-line
              />
            </template>
          </v-edit-dialog>
          <template v-else>
            {{ props.item[header.value] }}
          </template>
        </td>
        <td v-if="deletable">
          <v-icon
            small
            @click="deleteItem(props.index)"
          >
            mdi-delete
          </v-icon>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    props: {
      deletable: {
        type: Boolean
      },
      items: {
        type: Array,
        default: () => [],
      },
      headers: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        search: ''
      }
    },
    methods: {
      deleteItem (index) {
        this.items.splice(index, 1)
        this.$emit('save', this.items)
      }
    }
  }
</script>
